<template>
  <transition name="mask-bg-fade">
    <div class="mask" v-show="show" @click="clodeMask">
      <div class="mask-bg"></div>
      <transition name="slide-fade">
        <div class="model-box" v-show="show">
          <div class="close-model" v-on:click="closeModel()"></div>
          <div class="model-main" v-if="!this.$slots.model_box">
            <!-- <div class="title">{{ confirmModalOptions.title || '提示' }}</div> -->
            <div class="message text-center">
              <img
                class="tip-icon"
                src="../../../assets/images/ic_ask.png"
                alt="提示图"
              />
              <span>{{ confirmModalOptions.message || ' ' }}</span>
            </div>
          </div>
          <slot name="model_box"></slot>
          <div class="model-btn_box">
            <button
              v-show="confirmModalOptions.type === 'confirm'"
              class="button-default"
              v-on:click="confirmCancel()"
              :style="{ backgroundColor: confirmModalOptions.btnCancelBg }"
            >
              {{ confirmModalOptions.btnCancelText || '取消' }}
            </button>
            <button
              class="button-done"
              v-on:click="confirmSubmit()"
              :style="{ backgroundColor: confirmModalOptions.btnSubmitBg }"
            >
              {{ confirmModalOptions.btnSubmitText || '确定' }}
            </button>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
/*
 * @name: 询问框组件
 * @description:询问框组件
 * @author: zefeng(zefeng.chen@shengyc.com)
 * @Date: 2019-05-31 10:38:53
 * @LastEditTime: 2019-05-31 10:38:53
 */

export default {
  /**
   * confirmModalOptions
   * type:<String> 提示框类型  warning 警告  confirm 询问
   * title:<String> 标题
   * message:<String> 提示内容
   * btnCancelBg:<String> 取消按钮背景色
   * btnCancelText:<String>取消按钮文本
   * btnCancelFunction:<Fun> 取消按钮事件
   * btnSubmitBg:<String> 提交按钮背景色
   * btnSubmitText:<String> 提交按钮文本
   * btnSubmitFunction:<Fun> 提交按钮事件
   * model_box
   * 插槽 替换原始的询问框内容
   */
  props: { confirmModalOptions: Object },
  data() {
    return {
      show: false // 是否显示模态框
    };
  },
  methods: {
    closeModel: function() {
      this.show = false;
    },
    showModel: function() {
      this.show = true;
    },
    confirmCancel: function() {
      this.show = false;
      if (typeof this.confirmModalOptions.btnCancelFunction === 'function') {
        this.confirmModalOptions.btnCancelFunction();
      }
    },
    clodeMask: function() {
      this.show = false;
    },
    confirmSubmit: function() {
      this.show = false;
      if (typeof this.confirmModalOptions.btnSubmitFunction === 'function') {
        this.confirmModalOptions.btnSubmitFunction();
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../../assets/style/mixin';
.mask {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  // backdrop-filter: blur(vw(10));
  background-color: rgba(0, 0, 0, 0.5);
  @include fja(center, center);
  flex-direction: column;
}
.tip-icon {
  @include wh(vw(28), vw(28));
  margin-right: vw(12);
}
.message {
  @include fja(center, center);
  font-size: vw(16);
}
.model-box {
  width: 100%;
  .model-main {
    @include fja(center, center);
    flex-direction: column;
    background: #ffffff;
    height: 1vw (60);
    .title {
      @include sc(vw(14), #333333);
    }
  }
}
.model-btn_box {
  @include fja(space-between, center);
  padding: vw(8) vw(16);
  background: #ffffff;
  border-top: vw(1) solid rgb(115, 115, 115);
  button {
    flex: 1;
    height: vw(44);
    @include sc(vw(16), #ffffff);
    border-radius: vw(4);
    background-color: #0152b4;
    &:nth-child(1) {
      margin-right: vw(15);
    }
  }
  .button-default {
    background-color: #999999;
  }
}
.mask-bg-fade-enter-active,
.mask-bg-fade-leave-active {
  transition: opacity 0.3s;
}
.mask-bg-fade-enter,
.mask-bg-fade-leave-active {
  opacity: 0;
}
</style>
